<script lang="ts">
  import ImageOrVideo from "@shared/svelte/Components/ImageOrVideo.svelte";
  import TrackingContext from "@shared/svelte/Components/Tracking/TrackingContext.svelte";
  import { cloudinaryParams } from "@shared/services/discovery_image_dimensions";
  import { EventTracking } from "@shared/services/event_tracking/events";
  import { getCloudinaryUrl } from "@shared/services/cloudinary_image_url_service";
  import {
    SpotlightEntity,
    SpotlightAdEntity,
    CustomContentSpotlightEntity,
  } from "@shared/services/event_tracking/entities";
  import { reformatUrlAndGetTargetValue } from "@shared/services/target_value_forward_urls";

  export let title: string;
  export let description: string = "";
  export let forward_text: string = "";
  export let forward_url: string = "";
  export let video_upload_url: string = "";
  export let image_alt_text: string = "";
  export let image_upload_url: string = "";
  export let use_thumbnail: boolean = false;
  export let paid_tracking_values: any = null;
  export let id: number;
  export let position: number | null = null;

  // unused import from DiscoveryPanel.svelte
  export let mobileMode: boolean = false;
  mobileMode;

  const { trackClick, trackMrcEvents } = EventTracking;

  let trackingParams: (CustomContentSpotlightEntity | SpotlightEntity | SpotlightAdEntity)[];
  const trackingData = { id, position };

  if (trackingData.position !== null) {
    trackingParams = [new CustomContentSpotlightEntity(trackingData)];
  } else {
    trackingParams = [new SpotlightEntity()];
  }

  if (paid_tracking_values) {
    const spotlightAdEntity = new SpotlightAdEntity({
      ...paid_tracking_values,
      custom_content_spotlight_id: id,
    });
    trackingParams = trackingParams.concat([spotlightAdEntity]);
  }

  const { href, target } = reformatUrlAndGetTargetValue(forward_url);

  let imageUploadUrl: string;
  if (image_upload_url) {
    imageUploadUrl = getCloudinaryUrl(image_upload_url, cloudinaryParams.spotlight);
  }
</script>

<TrackingContext entities={trackingParams} let:trackingContext>
  <section
    data-testid="spotlight"
    use:trackMrcEvents={[trackingContext.entities]}
    class="fizz-surface-blue fizz-stack-16"
  >
    <div
      class="fizz-container fizz-inset-stretch-32 fizz-flex-row-responsive"
      style="max-width: 1080px;"
    >
      <div class="fizz-flex-item">
        <h3 class="fizz-heading-3 fizz-stack-16">{title}</h3>
        <p class="fizz-text-subdued fizz-stack-16">{description}</p>
        {#if forward_text && forward_url}
          <a
            {href}
            {target}
            data-testid="spotlight-button"
            class="fizz-button fizz-inline-block"
            on:click={e => trackClick("spotlight_button", trackingContext.entities)}
          >
            {forward_text || "Button label"}
          </a>
        {/if}
      </div>
      <div class="fizz-flex-item">
        <ImageOrVideo
          imageAltText={image_alt_text}
          {imageUploadUrl}
          index={position}
          objectPrefix={"spotlight"}
          trackingParams={trackingContext.entities}
          useThumbnail={use_thumbnail}
          videoUploadUrl={video_upload_url}
        />
      </div>
    </div>
  </section>
</TrackingContext>
